import { Flex, Button } from '.';
import { useTestContext } from '../../../../context/testContext';
import { confirmNavigation } from '../../../../helpers/functions';

const NavButtons = ({ updateStep, canProgress, marginTop }) => {
  const {
    testData: { testInProgress },
  } = useTestContext();

  return (
    <Flex marginTop={marginTop}>
      <Button
        variant='outlined'
        marginRight='1rem'
        onClick={() => (testInProgress ? confirmNavigation().then(() => updateStep('back')) : updateStep('back'))}
      >
        Back
      </Button>
      <Button
        disabled={!canProgress}
        onClick={() => {
          updateStep('next');
        }}
      >
        Next
      </Button>
    </Flex>
  );
};

export default NavButtons;
